import { Component } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AlertService } from "../core/services/alert.service";
import { AlarmService } from "../core/services/alarm.service";
import { DbService } from "../core/services/db.service";
import { PushService } from "../core/services/push.service";
import { CommonService } from "../core/services/common.service";

@Component({
  selector: "app-push-modal",
  templateUrl: "./push-modal.component.html",
  styleUrls: ["./push-modal.component.scss"],
})
export class PushModalComponent {
  uuids: string[] = [];
  content = "";
  userType = "";

  constructor(
    public modalService: NgbModal,
    private alertService: AlertService,
    private alarmService: AlarmService,
    private db: DbService,
    private pushService: PushService,
    private commonService: CommonService,
  ) {}

  ngOnInit(): void {}

  // 푸시 보내기
  async sendPush() {
    try {
      // 필수값 확인
      if (!this.content) {
        this.alertService.errormsg("내용을 입력해주세요.");
        return;
      }
      const memberAlarmUrl = `/user-list`;
      const sendUsers = [...new Set(this.uuids)];
      for await (const uuid of sendUsers) {
        let tmp = {
          id: this.commonService.generateFilename(),
          uuid: uuid,
          dateCreated: new Date().toISOString(),
          title: "TOMSS",
          content: this.content,
          url: "",
        };
        this.alarmService.memberPush(tmp, uuid, memberAlarmUrl);
      }

      this.alertService.swalToast("푸시 알림 전송 완료");
      this.modalService.dismissAll();
    } catch (error) {
      console.error("푸시 알림 전송 중 오류:", error);
      this.alertService.errormsg("푸시 알림 전송 중 오류가 발생했습니다.");
    }
  }
}
